import Translate from "lang/Translate";
import { Fragment } from "react";

const BadRequestError = () => {
  return (
    <Fragment>
      <div className="tile">
        <div className="error-content">
          <Translate text="Content.pageNotFoundTableHeader" />
          <div>
            <Translate text="Content.BadRequestLabel" />
          </div>
          <div>
            <Translate text="Content.BadRequest_DescribeYourIssue" />
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default BadRequestError